(() => {
  const root = window.Shopify?.routes?.root || '/';
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.bw-product-form') || event.defaultPrevented) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled || button.dataset.bwSubmitting === 'true') return;
    button.dataset.bwSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', body: new FormData(form), credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
      document.dispatchEvent(new CustomEvent('berrigan:cart-added', { detail: { button } }));
      document.dispatchEvent(new Event('cart:refresh'));
    } catch (error) {
      let status = form.querySelector('.bw-cart-error');
      if (!status) {
        status = document.createElement('p');
        status.className = 'bw-cart-error';
        status.setAttribute('role', 'alert');
        button.insertAdjacentElement('afterend', status);
      }
      status.textContent = error.message || 'This item could not be added. Please try again.';
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      button.dataset.bwSubmitting = 'false';
      button.disabled = !form.querySelector('[name="id"]')?.value;
    }
  });
})();
